jQuery(function($) {
	$(window).scroll(function() {
		// Add class to navbar on scroll  and 
		// only if width is > $grid-float-breakpoint for smoother transitions
		// if ( ($(document).scrollTop() > 60) && ($(window).width() > 768) ) {

		// Add class to navbar on scroll
		if ($(document).scrollTop() > 60) {
			$('.navbar').addClass("collapsed");
			$('body').addClass('collapsed-nav');
		} else {
			$('.navbar').removeClass('collapsed');
			$('body').removeClass('collapsed-nav');
		}
	});
});
